import React from 'react';
import { IconProps } from '.';

const SvgClock = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M10.75 7v5.901l4.834 3.223.832-1.248-4.166-2.777V7h-1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgClock;
